//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import IconView from "@/components/objects/IconView.vue";
import { gsap } from 'gsap'
import { Skeleton } from "ant-design-vue";
import "ant-design-vue/es/skeleton/style/index.css";
import { DesignExtra } from "@/utils/dto/objects.js";
import { datesToHuman } from "@/utils/dates.js";
import { adjustColorBrightness, buildMaskStyle } from "@/utils/helpers.js";
import TheMaskIcon from '@/components/objects/TheMaskIcon.vue';

export default {
  name: "LineEvents",
  components: { IconView, "a-skeleton": Skeleton, TheMaskIcon },
  inject: {
    specialProject: {
      default: false,
    },
    source: { default: "" },
  },
  props: {
    list: { type: Object, default: () => ({}) },
    listInfo: { type: Object, default: () => ({}) },
    prepopulatedItems: { type: Array, default: () => [] },
    design_extra: { type: [Object, DesignExtra], default: () => ({}) },
    user: { type: Object, default: () => ({}) },
    useStorage: { type: Boolean, default: false },
    object_id: { type: String, default: "" },
    objectLabel: { type: String, default: "" },
    detail: { type: Boolean, default: false },
    templateValue: { type: Object, default: () => null },
    design: { type: String, default: () => "default" },
    theme: { type: String, default: () => "default" },
  },
  data() {
    return {
      ready: false,
      itemHeights: [],
      scrollObserver: null,
      animatedItems: null,
    };
  },
  computed: {
    localDetail: {
      get() {
        return this.detail;
      },
      set(val) {
        this.$emit("detail", val);
      },
    },
    domId() {
      return `events-${this.list.id}`;
    },
    template() {
      return this.templateValue;
    },
    visibleItems() {
      return this.prepopulatedItems.map((item) => {
        if (item.loader) return item;
        const humanLabel = item.use_full_label
          ? (item.target_object?.label || item.target_object?.short_label)
          : (item.target_object?.short_label || item.target_object?.label);
        return { ...item, humanLabel };
      });
    },
    paletteList() {
      return this.$store.state["property_templates"]?.["consts"]?.palette ?? [];
    },
    bgPalette() {
      if (this.design_extra?.bg?.palette && this.paletteList?.length) {
        return this.paletteList.find((el) => el.id === this.design_extra.bg.palette);
      }
      return null;
    },
    iconBorderPalette() {
      if (this.design_extra?.icon_border?.palette && this.paletteList?.length) {
        return this.paletteList.find((el) => el.id === this.design_extra.icon_border.palette);
      }
      return null;
    },
    iconBgPalette() {
      if (this.design_extra?.icon_bg?.palette && this.paletteList?.length) {
        return this.paletteList.find((el) => el.id === this.design_extra.icon_bg.palette);
      }
      return null;
    },
    getMask() {
      return this.design_extra?.mask?.name ?? null;
    },
    getTextColor() {
      return this.design_extra?.text?.color ?? null;
    },
    getIconColor() {
      return this.design_extra?.icon_color?.color ?? "black";
    },
    getIconGradientEnabled() {
      return this.design_extra?.icon_bg?.gradient_enabled ?? null;
    },
    getIconGradientDirection() {
      return this.design_extra?.icon_bg?.gradient_direction ?? null;
    },
    getIconGradientShadowDirection() {
      return this.design_extra?.icon_bg?.gradient_shadow_direction ?? null;
    },
    getFirstBlockTitleColor() {
      return this.design_extra?.first_block?.title_color ?? null;
    },
    getFirstBlockBg() {
      if (this.getFirstBlockBgGradientEnabled && this.getFirstBlockBgColor) {
        return `linear-gradient(to ${this.getFirstBlockBgGradientDirection}, ${this.getFirstBlockBgGradientShadowDirection === 'transparent' ? `${this.getFirstBlockBgColor}, transparent` : `${this.getFirstBlockBgColor}, ${adjustColorBrightness((this.getFirstBlockBgColor), 1.20)}`})`
      }

      return this.getFirstBlockBgColor;
    },
    getFirstBlockBgColor() {
      return this.design_extra?.first_block?.bg_color ?? null;
    },
    getFirstBlockBgGradientEnabled() {
      return this.design_extra?.first_block?.gradient_enabled ?? null;
    },
    getFirstBlockBgGradientDirection() {
      return this.design_extra?.first_block?.gradient_direction ?? null;
    },
    getFirstBlockBgGradientShadowDirection() {
      return this.design_extra?.first_block?.gradient_shadow_direction ?? null;
    },
  },
  watch: {
    detail: {
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.updateHeights();
          });
        }
      },
      immediate: true,
    },
    prepopulatedItems: {
      handler() {
        this.$nextTick(() => {
          if (this.detail) {
            this.updateHeights();
          }
          if (this.ready) {
            this.setupScrollAnimations();
          }
        });
      },
      deep: true,
    },
  },
  mounted() {
    // eslint-disable-next-line nuxt/no-env-in-hooks
    if (process.client) {
      window.addEventListener('vistat:prepare-export', this.finishScrollAnimationsForExport);
      this.$nextTick(() => {
        this.ready = true;
        this.$nextTick(() => {
          this.setupScrollAnimations();
        });
      });
    }
  },
  destroyed() {
    window.removeEventListener('vistat:prepare-export', this.finishScrollAnimationsForExport);
    this.teardownScrollAnimations();
  },
  methods: {
    isScrollExportTarget(event) {
      const element = event?.detail?.element;
      return !!(element && this.$el && (this.$el === element || this.$el.contains(element) || element.contains(this.$el)));
    },
    finishScrollAnimationsForExport(event) {
      if (!this.isScrollExportTarget(event)) return;

      if (this.scrollObserver) {
        this.scrollObserver.disconnect();
        this.scrollObserver = null;
      }
      this.stopAllTweens();
      const animatedTargets = [
        ...this.$el.querySelectorAll('.events-list__dot, .events-list__arrow, .events-list__icon-wrap, .events-list__content, .events-list__date, .event--loader'),
      ].filter(Boolean);
      gsap.killTweensOf(animatedTargets);
      gsap.set(animatedTargets, { clearProps: 'transform,opacity' });
      this.animatedItems = new WeakSet();
    },
    addTween(tween) {
      if (!this._activeGsapTweens) this._activeGsapTweens = new Set();
      if (!tween) return tween;
      this._activeGsapTweens.add(tween);
      tween.eventCallback('onComplete', () => this._activeGsapTweens.delete(tween));
      return tween;
    },
    stopAllTweens() {
      if (!this._activeGsapTweens) return;
      this._activeGsapTweens.forEach((tween) => tween.kill());
      this._activeGsapTweens.clear();
    },
    teardownScrollAnimations() {
      if (this.scrollObserver) {
        this.scrollObserver.disconnect();
        this.scrollObserver = null;
      }
      this.stopAllTweens();
      this.animatedItems = null;
    },
    isScrollAnimationEnabled() {
      if (typeof window === 'undefined') return false;
      return !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    },
    clearGsapInlineStyles(elements, props = 'transform') {
      elements.filter(Boolean).forEach((el) => gsap.set(el, { clearProps: props }));
    },
    setupScrollAnimations() {
      if (typeof window === 'undefined' || typeof IntersectionObserver === 'undefined') return;
      if (!this.ready) return;

      const list = this.$el?.querySelector('.events-line__list');
      if (!list) return;

      if (!this.animatedItems) {
        this.animatedItems = new WeakSet();
      }

      if (!this.isScrollAnimationEnabled()) return;

      if (!this.scrollObserver) {
        this.scrollObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            this.animateListItem(entry.target);
            this.scrollObserver.unobserve(entry.target);
          });
        }, {
          threshold: 0.12,
          rootMargin: '60px 0px',
        });
      }

      list.querySelectorAll('li[data-scroll-item]').forEach((item) => {
        if (this.animatedItems.has(item)) return;
        this.prepareListItem(item);
        this.scrollObserver.observe(item);
      });
    },
    prepareListItem(li) {
      const isLeft = li.classList.contains('events-line__item--left');
      const dot = li.querySelector('.events-line__line-dot');
      const arrow = li.querySelector('.events-line__line-arrow');
      const iconWrap = li.querySelector('.events-line__icon-wrap');
      const content = li.querySelector('.events-line__content');
      const date = li.querySelector('.event__date');
      const loader = li.querySelector('.events-line__loader');

      if (dot) gsap.set(dot, { opacity: 0 });
      if (arrow) gsap.set(arrow, { width: '0%' });
      if (iconWrap) {
        gsap.set(iconWrap, {
          opacity: 0,
          x: isLeft ? -44 : 44,
          yPercent: -50,
        });
      }
      if (content) gsap.set(content, { opacity: 0, y: 12, scale: 0.96 });
      if (date) gsap.set(date, { opacity: 0 });
      if (loader) gsap.set(loader, { opacity: 0 });
    },
    animateListItem(li) {
      if (this.animatedItems?.has(li)) return;
      this.animatedItems.add(li);

      const dot = li.querySelector('.events-line__line-dot');
      const arrow = li.querySelector('.events-line__line-arrow');
      const iconWrap = li.querySelector('.events-line__icon-wrap');
      const content = li.querySelector('.events-line__content');
      const date = li.querySelector('.event__date');
      const loader = li.querySelector('.events-line__loader');

      const timeline = gsap.timeline({
        onComplete: () => {
          this.clearGsapInlineStyles([content]);
          this.clearGsapInlineStyles([iconWrap], 'opacity,x');
          this.clearGsapInlineStyles([dot, date, loader], 'opacity');
          if (arrow) gsap.set(arrow, { clearProps: 'width' });
        },
      });

      if (dot) {
        timeline.to(dot, {
          opacity: 1,
          duration: 0.55,
          ease: 'power2.out',
        }, 0);
      }

      if (arrow) {
        timeline.to(arrow, {
          width: '100%',
          duration: 0.85,
          ease: 'power2.out',
        }, 0.15);
      }

      const contentStart = 0.48;

      if (content) {
        timeline.to(content, {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 0.65,
          ease: 'back.out(1.35)',
        }, contentStart);
      }

      if (date) {
        timeline.to(date, {
          opacity: 1,
          duration: 0.5,
          ease: 'power2.out',
        }, contentStart + 0.08);
      }

      if (iconWrap) {
        timeline.to(iconWrap, {
          opacity: 1,
          x: 0,
          yPercent: -50,
          duration: 0.65,
          ease: 'back.out(1.35)',
        }, contentStart);
      }

      if (loader) {
        timeline.to(loader, {
          opacity: 1,
          duration: 0.45,
          ease: 'power2.out',
        }, contentStart + 0.15);
      }

      this.addTween(timeline);
    },
    loadItems() {
      this.$emit("load");
      this.$nextTick(() => {
        this.updateHeights();
      });
    },
    updateHeights() {
      const els = this.$refs.eventItem || [];
      this.itemHeights = Array.from(els).map(el =>
        el ? el.offsetHeight : 0
      );
    },
    checkNextItemHeight(index) {
      if (index === 0) return 0;
      const nextHeight = this.itemHeights[index + 1];
      if (!nextHeight) return 'unset';
      if (nextHeight > this.itemHeights[index]) {
        return 'unset';
      } else {
        return 'center';
      }
    },
    checkPrevItemHeight(index) {
      if (index === 0) return 0;
      const prevHeight = this.itemHeights[index - 1];
      if (!prevHeight) return 0;
      if (prevHeight > this.itemHeights[index]) {
        return 0;
      } else {
        return 40;
      }
    },
    onTemplateChange(evt) {
      this.$emit("template-change", evt);
    },
    async onDetailInput(evt) {
      this.$emit("detail", evt);

      if (this.template) {
        await this.$store.dispatch("makeRealtimeExample", {
          elementId: this.domId,
          title: this.listInfo.object_label,
          fileName: this.listInfo.label
            ? `${this.listInfo.object_label}_${this.listInfo.label}`
            : this.listInfo.object_label,
          icon: this.listInfo.icon,
          store: this.$store,
          styles: this.template?.styles,
          headerColumn: this.detail,
        });
      }
    },
    maskStyle(mask) {
      return buildMaskStyle(mask)
    },
    getItemIcon(item) {
      return item?.target_object?.event_icon || item?.target_object?.type?.icon || null;
    },
    getItemLabel(item) {
      return item?.humanLabel || item?.target_object?.short_label || item?.target_object?.label || "";
    },
    getItemText(item) {
      return item?.target_object?.text?.replace(/<\/?[^>]+(>|$)/g, "") || "";
    },
    getIconBorderColor(index) {
      if (this.iconBorderPalette) {
        const colors = [this.iconBorderPalette.main_color, ...(this.iconBorderPalette.colors || [])];
        return colors[index % colors.length];
      }
      return this.design_extra?.icon_border?.color ?? "#d7d7d7";
    },
    getBgColor(index) {
      if (this.bgPalette) {
        return [this.bgPalette.main_color, ...this.bgPalette.colors][index % [this.bgPalette.main_color, ...this.bgPalette.colors].length];
      } else if (this.design_extra?.bg?.color) {
        return this.design_extra.bg.color
      }

      return null;
    },
    getIconBgColor(index) {
      if (this.getIconGradientEnabled) {
        if (this.iconBgPalette) {
          const color = [this.iconBgPalette.main_color, ...this.iconBgPalette.colors][index % [this.iconBgPalette.main_color, ...this.iconBgPalette.colors].length];
          return `linear-gradient(to ${this.getIconGradientDirection}, ${this.getIconGradientShadowDirection === 'transparent' ? `${color}, transparent` : `${color}, ${adjustColorBrightness(color, 1.20)}`})`
        } else if (this.design_extra?.icon_bg?.color) {
          const color = this.design_extra.icon_bg.color;
          return `linear-gradient(to ${this.getIconGradientDirection}, ${this.getIconGradientShadowDirection === 'transparent' ? `${color}, transparent` : `${color}, ${adjustColorBrightness(color, 1.20)}`})`
        }
      } else {
        if (this.iconBgPalette) {
          return [this.iconBgPalette.main_color, ...this.iconBgPalette.colors][index % [this.iconBgPalette.main_color, ...this.iconBgPalette.colors].length];
        } else if (this.design_extra?.icon_bg?.color) {
          return this.design_extra.icon_bg.color
        }
      }

      return null;
    },
    getDates(event_date) {
      return datesToHuman(
        {
          value: event_date.vfrom,
        },
        {
          value: event_date.vto,
        },
        "object"
      );
    },
    hasMonthInDates(dates) {
      if (!Array.isArray(dates)) return false;

      const monthPatterns = /(январ|феврал|март|апрел|ма[йя]|июн|июл|август|сентябр|октябр|ноябр|декабр)/i;
      const numericDatePattern = /\d{1,2}\.\d{1,2}\.\d{2,4}/;

      return dates.some((d) => {
        if (!d || typeof d[0] !== "string") return false;
        const part = d[0];
        return monthPatterns.test(part) || numericDatePattern.test(part);
      });
    },
    hasMonthInPeriod(event_date) {
      if (!event_date) return false;

      const dates = this.getDates(event_date);
      if (!Array.isArray(dates) || !dates.length) return false;

      const hasMonth = this.hasMonthInDates(dates);
      if (!hasMonth) return false;

      const isPeriodByRaw =
        event_date.vto && event_date.vto !== event_date.vfrom;
      const isPeriodByArray = dates.length > 1;
      const isPeriodByHyphen =
        dates.length === 1 &&
        dates[0] &&
        typeof dates[0][0] === "string" &&
        /-/.test(dates[0][0]);

      return isPeriodByRaw || isPeriodByArray || isPeriodByHyphen;
    },
  },
};
